import { useFeature, useIsAuthorized } from '~/hooks'

export const useCanViewBotIntegrations = ({ workspaceId, userId }: { workspaceId: string; userId?: string }) => {
  const featureEnabled = useFeature('dashboard-integration-hub')
  const authorize = useIsAuthorized({ workspaceId, userId })
  if (!featureEnabled) {
    return false
  }
  return authorize('integrations.view')
}
